import pluralize from "pluralize";
import type { DispensationStatus, ItemInterface } from "../types";

// Configurar plurais em português
pluralize.addPluralRule("embalagem", "embalagens");
pluralize.addPluralRule("bastão", "bastões");
pluralize.addPluralRule("resta", "restam");

export function handleCanDispense(item: ItemInterface): boolean {
  const prescribedQuantity = item.prescribedQuantity ?? 0;
  const dispensedQuantity = item.dispensedQuantity ?? 0;
  const sub = prescribedQuantity - dispensedQuantity;
  return sub > 0;
}

export function getStrokeColor(percentage: number): string {
  if (percentage === 0) return "#d1d5db";
  if (percentage < 50) return "#f59e0b";
  if (percentage < 100) return "#d97706";
  return "#059669";
}

export function getFillColor(percentage: number): string {
  if (percentage === 0) return "transparent";
  if (percentage < 50) return "rgba(245, 158, 11, 0.15)";
  if (percentage < 100) return "rgba(217, 119, 6, 0.2)";
  return "rgba(5, 150, 105, 0.25)";
}

export function getStatus(ratio: number): DispensationStatus {
  if (ratio <= 0) return "Não dispensado";
  if (ratio >= 100) return "Totalmente dispensado";
  return "Dispensado parcialmente";
}

export function getLeftAmount(availableQuantity: number): string {
  const leftAmount = availableQuantity;
  if (leftAmount === 0) return "";
  const leftLabelPlural = pluralize('Resta', leftAmount);
  return `${leftLabelPlural}: ${leftAmount}`;
}

export function calculatePercentage(dispensedAmount: number, prescribedAmount: number): number {
  return prescribedAmount > 0 ? (dispensedAmount / prescribedAmount) * 100 : 0;
}